import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import usageManualAPI from '@infrastructure/usage-manual-api';
export const getAllUsageManualsAsync = createAsyncThunk('usageManual/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await usageManualAPI.getAll();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getLatestUsageManualAsync = createAsyncThunk('usageManual/getLatest', async (_, { rejectWithValue }) => {
    try {
        const response = await usageManualAPI.getLatest();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getNextVersionAsync = createAsyncThunk('usageManual/getNextVersion', async (_, { rejectWithValue }) => {
    try {
        const response = await usageManualAPI.getNextVersion();
        return response.data.nextVersion;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const uploadUsageManualAsync = createAsyncThunk('usageManual/upload', async ({ file, language, targetVersion }, { rejectWithValue }) => {
    try {
        const response = await usageManualAPI.upload(file, language, targetVersion);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const replaceUsageManualFileAsync = createAsyncThunk('usageManual/replaceFile', async ({ id, file }, { rejectWithValue }) => {
    try {
        const response = await usageManualAPI.replaceFile(id, file);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
